import { Box, Card, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import TelegramIcon from '@mui/icons-material/Telegram';

const Footer = () => {
    return (
        <>
            <Box className="footer" sx={{ mt: 2, mb: 2 }}>
                <Card>
                    <CardContent>
                        <Box gap={3} display='flex' justifyContent='space-between' alignItems='center' p={2}>
                            <Box gap={3} display='flex' alignItems='center'>
                                <Link to="/">Купить</Link>
                                <Link to="/term-and-conditions">Условия пользователя</Link>
                                <Link to='/policy'>Политика возврата и доставки</Link>
                                <Link to='/cookie-policy'>Политика куки</Link>
                                <Link to='/contacts'>Контакты</Link>
                                <Link to='/support'>Поддержка</Link>
                            </Box>
                            <Box gap={2} display='flex'>
                                <IconButton
                                    color="primary"
                                    component="a"
                                    href="https://t.me/gamecointrader"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <TelegramIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </>
    )
}

export default Footer;